import { GameReelProperties } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/properties/GameReelProperties";
import { FontStyle } from "@lib/titan2-slingo/dist/game/view/abstract/style/FontStyle";
import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { BitmapTextFieldProperties } from "@lib/titan2/dist/game/control/properties/BitmapTextFieldProperties";
import * as PIXI from "pixi.js";
import { BitmapFontStyles } from "../../../font/FontConstants";
/**
 * ReelLandscapeProperties.ts
 */
export class ReelLandscapeProperties extends GameReelProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.spinePosition = new PIXI.Point(0, 0);
        this.size = new PIXI.Point(160, 160);
        const yPosition = -110;
        this.symbolProperties = new BitmapTextFieldProperties(BitmapFontStyles.REEL_SYMBOL, FontStyle.REEL_SYMBOL, new PIXI.Point(6, yPosition), undefined, ControlConstants.CENTER, ControlConstants.CENTER, this.size.clone());
        this.symbolHighlightProperties = new BitmapTextFieldProperties(BitmapFontStyles.REEL_SYMBOL, FontStyle.REEL_SYMBOL, new PIXI.Point(6, yPosition), undefined, ControlConstants.CENTER, ControlConstants.CENTER, this.size.clone());
    }
}
